import { useEffect } from 'react';
var useTitle = function (title) {
    useEffect(function () {
        document.title = title;
    }, [title]);
};
export default useTitle;
